module.exports = __webpack_public_path__ + "img/33_38.e5840dc6.png";